import { Flex } from 'foundations-components/components/Flex';
import { LinkIcon } from 'foundations-assets/icons/components/LinkIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const WebDataSourceButton = ({
  children,
  source
}) => {
  // TODO: Populate icon with relevant icon (BE says it may be doable with enrichment)

  return children({
    // Domain and title are optional, but we ideally want to use "{domain} | {title}" here.
    // But, if we are missing some of these pieces, try to substitute with the closest thing we have.
    primaryText: source.domain || source.url,
    secondaryText: source.title ? source.title : source.domain ? source.url : undefined,
    icon: /*#__PURE__*/_jsx(Flex, {
      as: "span",
      flexShrink: 0,
      alignItems: "center",
      children: /*#__PURE__*/_jsx(LinkIcon, {})
    }),
    href: source.url
  });
};